// @flow
import kebabCase from 'lodash/kebabCase'
import type { Gathering } from 'types'

declare var ENV: any

export default function gatheringUrl(gathering: Gathering): string {
  const slug = `${kebabCase(gathering.name)}-${gathering.id}`

  const state =
    gathering.address && gathering.address.state ? kebabCase(gathering.address.state) : '_'

  const city = gathering.address && gathering.address.city ? kebabCase(gathering.address.city) : '_'

  return `/${state}/${city}/events/${slug}`
}
